import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import AddNewJob from './pages/AddNewJob';
import EditJob from './pages/EditJob';
import Homepage from './pages/Homepage';
import './style.css';

function App() {
  return (
    <>
    <Layout>
      <Routes>
        <Route path={"/"} element={<Homepage/>}/>
        <Route path={"/addnew"} element={<AddNewJob/>}/>
        <Route path={"/editjob"} element={<EditJob/>}/>
      </Routes>
    </Layout>
    </>
  );
}

export default App;
